// @flow

import * as React from 'react';

// Can be used as child function to <FormattedMessage />.
const parenthesize = (node: React.Node) =>
  typeof node === 'string' ? `(${node})` : node;

export default parenthesize;
